export default __webpack_public_path__ + "static/media/handshake.d65e5dba.png";